import { render, staticRenderFns } from "./SpecialityList.vue?vue&type=template&id=1926e91a&"
import script from "./SpecialityList.vue?vue&type=script&lang=js&"
export * from "./SpecialityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports